import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

export const ExpertiseSection = () => {
  const areas = [
    {
      category: "Hotel Management",
      description: "Gezielte Besetzung von Führungspositionen in der Hotellerie – vom Boutique-Hotel bis zur internationalen Kette",
      positions: ["General Manager", "Operations Director", "Geschäftsführer"],
      highlight: "Seit 2002 weltweit vernetzt",
      link: "/unternehmen"
    },
    {
      category: "Kulinarische Bereiche", 
      description: "Expertenvermittlung für Schlüsselpositionen in Gastronomie und Kulinarik – täglich bringen wir Top-Talente und Betriebe zusammen",
      positions: ["Executive Chef", "F&B Director", "Culinary Director"],
      highlight: "Michelin-Stern Erfahrung",
      link: "/unternehmen"
    },
    {
      category: "Revenue & Strategy",
      description: "Strategische Neubesetzung zur Umsatzoptimierung – wir kennen die Bewerbenden, die Ihre Geschäftsziele erreichen",
      positions: ["Revenue Manager", "Sales Director", "Commercial Director"],
      highlight: "ROI-orientierte Vermittlung",
      link: "/unternehmen"
    },
    {
      category: "Verpachtung",
      description: "Spezialisierte Vermittlung und Verpachtung von Objekten – für nachhaltigen Erfolg in der Hospitality",
      positions: ["Pächter", "Betriebsleiter", "Asset Manager"],
      highlight: "Langfristige Partnerschaften",
      link: "/verpachtung"
    }
  ];

  return (
    <section id="expertise" className="py-16 sm:py-24 relative overflow-hidden" style={{ background: 'var(--gradient-organic)' }}>
      <div className="container mx-auto px-4 sm:px-8">
        {/* Simple Header */}
        <div className="text-center max-w-4xl mx-auto mb-12 sm:mb-16">
          <span className="text-primary font-medium text-sm tracking-wider uppercase mb-4 block">
            Für Unternehmen
          </span>
          
          <h2 className="text-3xl sm:text-5xl font-display font-extralight bg-gradient-to-br from-foreground via-foreground to-primary bg-clip-text text-transparent mb-6 leading-tight">
            Unsere Kernbereiche
          </h2>
          
          <p className="text-lg text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            Als spezialisierter Headhunter für die Hospitality besetzen wir Führungspositionen 
            und vermitteln Verpachtungen. 25 Jahre Erfahrung in der gezielten Suche nach den 
            besten Bewerbenden und passenden Pächtern.
          </p>
          
          {/* Cross-selling hint for candidates */}
          <p className="text-sm text-muted-foreground mt-4">
            <span className="opacity-60">Sie suchen einen Job? </span>
            <Button 
              variant="link" 
              className="text-primary hover:underline font-medium p-0 h-auto"
              onClick={() => window.location.href = '/stellenangebote'}
            >
              Alle Stellenangebote ansehen →
            </Button>
          </p>
        </div>
        
        {/* Clean Grid Layout */}
        <div className="grid sm:grid-cols-2 gap-6 max-w-5xl mx-auto">
          {areas.map((area, index) => (
            <Link
              key={index}
              to={area.link}
              className="block bg-card/80 backdrop-blur-sm border border-border/60 rounded-xl p-6 shadow-sm hover:bg-card hover:border-primary/40 hover:shadow-xl hover:shadow-primary/5 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
            >
              <div className="space-y-4">
                <h3 className="text-xl font-display font-medium text-foreground">
                  {area.category}
                </h3>
                <p className="text-muted-foreground leading-relaxed">
                  {area.description}
                </p>
                
                <div className="space-y-2">
                  {area.positions.map((position, idx) => (
                    <div key={idx} className="flex items-center text-sm">
                      <div className="w-1.5 h-1.5 bg-primary rounded-full mr-3"></div>
                      <span className="text-foreground">
                        {position}
                      </span>
                    </div>
                  ))}
                </div>
                
                <div className="pt-2">
                  <span className="inline-block px-3 py-1 rounded-lg bg-primary/10 text-primary text-sm font-medium">
                    {area.highlight}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
        
        {/* Buttons CTA */}
        <div className="text-center mt-16">
          <div className="max-w-2xl mx-auto space-y-6">
            <p className="text-lg text-muted-foreground mb-6">
              Sie suchen außerhalb dieser Bereiche?
              <span className="block text-foreground font-medium mt-2">
                Sprechen wir über Ihre individuellen Anforderungen.
              </span>
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button asChild variant="outline" size="lg" className="font-medium">
                <Link to="/managementleistungen">
                  Managementleistungen
                </Link>
              </Button>
              <Button asChild variant="default" size="lg" className="font-medium">
                <Link to="/bewerbende">
                  Für Bewerbende
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};